import decisionMakingToolProject from "./decisionMakingTool-Project";
import emailTemplatesProject from "./emailTemplates-Project";
import InfoExpProject from "./infoExp-Project";
import mSEProject from "./mSE-Project";
import rgbdleProject from "./rgbdle-Project";
import ScrollingInfoProject from "./scrollingInfo-Project";
import surveyRedesignProject from "./surveyRedesign-Project";
import TheCenterWordpress from "./theCenterWordpress-Project";
import vibesEmailProject from "./vibesEmail-Project";
import voisparkProject from "./vs3-Project";

export const interactiveProjects = [
    InfoExpProject,
    rgbdleProject,
    ScrollingInfoProject,
    decisionMakingToolProject,
    surveyRedesignProject
];

export const databaseProjects = [
    voisparkProject,
    TheCenterWordpress
];

export const emailProjects = [
    emailTemplatesProject,
    vibesEmailProject
];

export const automationProjects = [
    mSEProject
];